export default "__VITE_ASSET__CHAV6cu$__"